import { DocumentReference, DocumentData, AngularFirestore } from "@angular/fire/firestore";
import * as firebase from "firebase";
import { environment } from "src/environments/environment";
import { City } from "./city.model";

export class CityBuilder {
  public reference: DocumentReference;
  public name: string;
  public coordinates: firebase.firestore.GeoPoint;
  public image: string;
  public isActive: boolean;
  public state: string;
  public timezone: string;
  public totalActiveVenues: number;
  public totalVenues: number;
  public isBannerActive: boolean;
  public bannerImage: string;
  public bannerText: string;
  public isBannerRedirectActive: boolean;
  public bannerRedirectUrl: string;
  public redirect: boolean;
  public redirectUrl: string;
  public addUserId: boolean;

  constructor() {
    this.addUserId = false;
  }

  build(): City {
    return new City(this);
  }

  public get hasReference(): boolean {
    return this.reference != null;
  }

  edit(city: City): CityBuilder {
    this.reference = city.reference;
    this.name = city.name;
    this.coordinates = city.coordinates;
    this.image = city.image;
    this.bannerImage = city.bannerImage;
    this.isBannerActive = city.isBannerActive;
    this.bannerText = city.bannerText;
    this.addUserId = city.addUserId ?? false;

    this.redirect = city.redirect;
    this.redirectUrl = city.redirectUrl;
    this.bannerRedirectUrl = city.bannerRedirectUrl;
    this.isBannerRedirectActive = city.isBannerRedirectActive;
    this.isActive = city.isActive;
    this.state = city.state;
    this.timezone = city.timezone;
    this.totalActiveVenues = city.totalActiveVenues;
    this.totalVenues = city.totalVenues;
    return this;
  }

  create(
    form: any,
    image: string,
    coordinates: firebase.firestore.GeoPoint,
    timezone: string,
    reference?: DocumentReference
  ): CityBuilder {
    this.bannerImage = form.bannerImage;
    this.bannerText = form.bannerText;
    this.isBannerActive = form.isBannerActive;
    this.isBannerRedirectActive = form.isBannerRedirectActive;
    this.bannerRedirectUrl = form.bannerRedirectUrl;
    this.redirect = form.redirect;
    this.redirectUrl = form.redirectUrl;
    this.name = form.name;
    this.state = form.state;
    this.isActive = form.isActive;
    this.image = image;
    this.coordinates = coordinates;
    this.timezone = timezone;
    this.totalActiveVenues = 0;
    this.addUserId = false;
    this.totalVenues = 0;
    if (reference != null) this.reference = reference;
    return this;
  }

  loadAPIResponse(data: any, db: AngularFirestore) {
    this.reference = db.doc(`${environment.cities}/${data.id}`).ref;
    this.name = data.name;
    this.bannerImage = data.bannerImage ?? "";
    this.bannerText = data.bannerText ?? "";
    this.isBannerActive = data.isBannerActive ?? false;
    this.isBannerRedirectActive = data.isBannerRedirectActive ?? false;
    this.bannerRedirectUrl = data.bannerRedirectUrl ?? "";
    this.state = data.state;
    this.isActive = data.isActive;
    this.redirect = data.redirect ?? false;
    this.redirectUrl = data.redirectUrl ?? "";
    this.image = data.image;
    this.coordinates = new firebase.firestore.GeoPoint(data.coordinates._latitude, data.coordinates._longitude);
    this.addUserId = data.addUserId ?? false;
    this.timezone = data.timezone;
    this.totalActiveVenues = data.totalActiveVenues ?? 0;
    this.totalVenues = data.totalVenues ?? 0;
    return this;
  }
}
